import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';

import { SharePopupComponent } from './share-popup.component';

// SharePopupComponent (<app-share-popup>) is used by high-lights-details
// (stays in HomeModule) and listing-details (moving to its own lazy module) -
// needs its own module so both can import it independently.
@NgModule({
  declarations: [SharePopupComponent],
  imports: [CommonModule, TranslateModule, DialogModule, ToastModule],
  exports: [SharePopupComponent],
})
export class SharePopupModule {}
